/* tslint:disable */
/* eslint-disable */
export enum UserRolesForSiteAdmin {
  Carrier = 'carrier',
  Consignee = 'consignee',
  Consignor = 'consignor',
  SiteAdmin = 'site_admin'
}
